import {
  // default
  createDrawPointMode,
  createDrawLineStringMode,
  createDrawPolygonMode,
  createDrawNodesMode,
  createDrawLinksMode,
  createDrawZonesMode,
  createDrawConnectorsMode,
  createSimpleSelectMode,
  createDirectSelectMode,
  // traffic counts
  createTCSimpleSelectMode,
  createTCDirectSelectMode,
  createDrawGeneralCountPointMode,
  // public transport
  createPTSimpleSelectMode,
  createPTDirectSelectMode,
  createDrawStopPointsMode,
  createDrawRoutesMode,
  // event editor
  createEESimpleSelectMode,
  createEEDirectSelectMode,
  createEEDrawPointsMode,
  createEEDrawLinesMode,
  createEEDrawPolygonsMode,
  // calculations
  createCSimpleSelectMode,
  createCDrawPointsMode
} from "./creators";

export class ModesController {
  constructor(map, MapboxDraw, type) {
    this.map = map;
    this.MapboxDraw = MapboxDraw;
    this.mapgl = map.map;
    this.state = map[type];
  }

  // common select modes
  createSimpleSelectMode() {
    return createSimpleSelectMode(this.MapboxDraw, this.state, this.map);
  }
  createDirectSelectMode() {
    return createDirectSelectMode(this.MapboxDraw, this.state, this.map);
  }

  // common draw modes
  createDrawPointMode() {
    return createDrawPointMode(this.MapboxDraw, this.state, this.map);
  }
  createDrawLineStringMode() {
    return createDrawLineStringMode(this.MapboxDraw, this.state, this.map);
  }
  createDrawPolygonMode() {
    return createDrawPolygonMode(this.MapboxDraw, this.state, this.map);
  }

  // model draw modes
  createDrawNodesMode() {
    return createDrawNodesMode(this.MapboxDraw, this.state, this.map);
  }
  createDrawLinksMode() {
    return createDrawLinksMode(this.MapboxDraw, this.state, this.map);
  }
  createDrawZonesMode() {
    return createDrawZonesMode(this.MapboxDraw, this.state, this.map);
  }
  createDrawConnectorsMode() {
    return createDrawConnectorsMode(this.MapboxDraw, this.state, this.map);
  }

  // traffic counts modes
  createTCSimpleSelectMode() {
    return createTCSimpleSelectMode(this.map, this.MapboxDraw, this.state);
  }
  createTCDirectSelectMode() {
    return createTCDirectSelectMode(this.MapboxDraw);
  }
  createDrawGeneralCountPointMode() {
    return createDrawGeneralCountPointMode(
      this.map,
      this.MapboxDraw,
      this.state
    );
  }

  // public transpot modes
  createPTSimpleSelectMode() {
    return createPTSimpleSelectMode(this.MapboxDraw, this.state, this.map);
  }
  createPTDirectSelectMode() {
    return createPTDirectSelectMode(this.MapboxDraw, this.state, this.map);
  }
  createDrawStopPointsMode() {
    return createDrawStopPointsMode(this.MapboxDraw, this.state, this.map);
  }
  createDrawRoutesMode() {
    return createDrawRoutesMode(this.MapboxDraw, this.state, this.map);
  }

  // event editor modes
  createEESimpleSelectMode() {
    return createEESimpleSelectMode(this.MapboxDraw, this.state, this.map);
  }
  createEEDirectSelectMode() {
    return createEEDirectSelectMode(this.MapboxDraw, this.state, this.map);
  }
  createEEDrawPointsMode() {
    return createEEDrawPointsMode(this.MapboxDraw, this.state, this.map);
  }
  createEEDrawLinesMode() {
    return createEEDrawLinesMode(this.MapboxDraw, this.state, this.map);
  }
  createEEDrawPolygonsMode() {
    return createEEDrawPolygonsMode(this.MapboxDraw, this.state, this.map);
  }

  // calculations
  createCSimpleSelectMode() {
    return createCSimpleSelectMode(this.MapboxDraw, this.map);
  }
  createCDrawPointsMode() {
    return createCDrawPointsMode(this.MapboxDraw, this.map);
  }
}
